import Vue from 'vue'

// Layout components
Vue.component('app-header', require('./Header/Header').default)
Vue.component('app-sidebar', require('./Sidebar/Sidebar').default)
Vue.component('app-notifications', require('./Notifications/Notifications').default)
Vue.component('app-search', require('./Searching/Search').default)
Vue.component('create-channel', require('./Global/CreateChannel').default)
Vue.component('snackbars', require('./Global/Snackbars').default)
Vue.component('heartbeat', require('./Global/Heartbeat').default)

// Pages
Vue.component('job', require('./Job/Job').default)
Vue.component('channel', require('./Channel/Channel').default)
Vue.component('channel-settings', require('./Channel/Settings').default)
Vue.component('account-settings', require('./Account/Settings').default)
Vue.component('user-settings', require('./Global/UserSettings').default)
